import styles from './ModalFelmeddelande.module.css';
import classNames from 'classnames';
import { useKartstodContext } from './contexts/KartstodContext';

const ModalFelmeddelande = () => {
  const { felmeddelande, visaFelmeddelande, setVisaFelmeddelande } =
    useKartstodContext();

  const stangFelmeddelande = () => {
    setVisaFelmeddelande(false);
  };

  return (
    <div
      className={classNames(
        styles.felmeddelandeContainer,
        visaFelmeddelande ? styles.bounceInLeft : styles.closeBounce
      )}
    >
      <div className={styles.FMText}>{felmeddelande}</div>
      <div className={styles.FMKryss} onClick={stangFelmeddelande}>
        X
      </div>
    </div>
  );
};

export default ModalFelmeddelande;
